import { render, staticRenderFns } from "./EstimateRequests.vue?vue&type=template&id=70dba0ec"
import script from "./EstimateRequests.vue?vue&type=script&lang=ts"
export * from "./EstimateRequests.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports